import { gql, useQuery } from '@apollo/client';

import {
  useCanViewGroupContent_groupQuery,
  useCanViewGroupContent_groupQueryVariables,
} from './graphql-types/useCanViewGroupContent_groupQuery';

const GROUP_QUERY = gql`
  query useCanViewGroupContent_groupQuery($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        settings {
          communityVisibility
        }
        currentUserGroupPermission {
          canViewContent
        }
        isCurrentUserIsAdmin
      }
    }
  }
`;

export const useCanViewGroupContent = (
  groupId: string
): {
  loading: boolean;
  canViewGroupContent: boolean | undefined;
  communityVisibility : any;
  isCurrentUserIsAdmin : boolean | undefined | null;
} => {
  const query = useQuery<
    useCanViewGroupContent_groupQuery,
    useCanViewGroupContent_groupQueryVariables
  >(GROUP_QUERY, { variables: { input: { _id: groupId } } });

  return {
    loading: query.loading,
    canViewGroupContent:
      !!query.data?.group.result?.currentUserGroupPermission?.canViewContent,
      communityVisibility : query.data?.group.result?.settings.communityVisibility,
    isCurrentUserIsAdmin: query.data?.group.result?.isCurrentUserIsAdmin
  };
};
